import React, {PureComponent} from 'react';
import './Home.css';
import * as Typed from 'typed.js';

import ProgressBar from 'progressbar.js';
import {Link} from 'react-scroll';
import ReactDOM from "react-dom";

class Front extends PureComponent {

    bar;

    componentDidMount() {
        setTimeout(() => {
            new Typed('.title', {
                strings: ['live^200 ülekanded', 'afte^100rmovied^200', 'koolitused', 'saadete^200 salve^200stused'
                    , 'lühifilmid'],
                typeSpeed: 50,
                smartBackspace: true,
                backDelay: 1000,
                backSpeed: 40,
                showCursor: true,
                cursorChar: '|',
                autoInsertCss: true,
                loop: true,
                startDelay: (1000)
            });
        }, 1000);
        this.bar = new ProgressBar.Circle('#container', {
            easing: 'easeInOut',
            trailColor: '#888',
            color: '#fff',
            duration: 700
        });
    }

    componentDidUpdate() {
        let hash = this.props.location.hash.replace('#', '');
        if (hash) {
            let node = ReactDOM.findDOMNode(this.refs[hash]);
            if (node) {
                node.scrollIntoView();
            }
        }
    }


    render() {
        return (
            <div id="front">
                <div id="home-background-wrap">
                    <div id="home-background"/>
                </div>
                <img id="fk-logo" src="assets/fk.png" className="header-reveal"/>
                <div id="typed" className="start-animated">
                    <span id="fk-holder">
                        <span id="fk-text"><a>FILMIKLUBI</a></span>
                        <span id="fk-divider"/>
                    </span>
                    <span id="fk-title">
                        <span className="title"/>
                    </span>
                </div>
                <div className="hello start-animated">
                    <div className="hello-text">Võta ühendust</div>
                    <a className="hello-ref" href="mailto:info@filmiklubi.ee">info@filmiklubi.ee</a>
                </div>
                <Link spy={false} smooth={true} className="contact start-animated" to="order">
                    <div id="container"
                         onMouseOver={() => this.bar.animate(1)}
                         onMouseLeave={() => this.bar.animate(0)}/>
                    <p id="join-text"
                       onMouseOver={() => this.bar.animate(1)}
                       onMouseLeave={() => this.bar.animate(0)}>
                        Kontakt
                    </p>
                </Link>
                <div className="scroll-sign bottom-reveal">
                    <span className="home-scroll-line"/>
                    <p className="home-scroll">scroll</p>
                </div>
            </div>
        );
    }
}

export default Front;



// WEBPACK FOOTER //
// ./src/home/Home.js